import type Dexie from "dexie";

/**
 * IndexedDB schema versions are independent from the static dataset schema.
 * Keep every version declaration so Dexie can upgrade old browser profiles in
 * order without rebuilding or clearing user-owned data.
 */
export const DATABASE_SCHEMA_VERSION = 2;

export const DATABASE_STORES_V1 = {
  remoteNotices:
    "&id, &canonicalKey, applicationEndAt, category, status, agency, eligibilityStatus, fitScore, lastSeenAt",
  remoteChanges: "&id, noticeId, importance, detectedAt",
  remoteEvaluations: "&noticeId, eligibilityStatus, fitScore, fitGrade",
  userNotices: "&noticeId",
  syncRuns: "&id",
  settings: "&key",
} as const;

// v2 deliberately keeps the same indexes. It adds sourceNoticeIds to existing
// user records as a non-indexed migration aid for a future canonical-key change.
export const DATABASE_STORES_V2 = DATABASE_STORES_V1;

export function registerDatabaseMigrations(database: Dexie): void {
  database.version(1).stores(DATABASE_STORES_V1);

  database
    .version(DATABASE_SCHEMA_VERSION)
    .stores(DATABASE_STORES_V2)
    .upgrade(async (transaction) => {
      await transaction
        .table("userNotices")
        .toCollection()
        .modify((record: Record<string, unknown>) => {
          if (!Array.isArray(record.sourceNoticeIds)) {
            record.sourceNoticeIds = [];
          }
        });

      await transaction.table("settings").put({
        key: "databaseSchemaVersion",
        value: DATABASE_SCHEMA_VERSION,
        updatedAt: new Date().toISOString(),
      });
    });

  database.on("populate", (transaction) =>
    transaction.table("settings").add({
      key: "databaseSchemaVersion",
      value: DATABASE_SCHEMA_VERSION,
      updatedAt: new Date().toISOString(),
    }),
  );
}
